import { Box, LinearProgress } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { removeAccents } from "constants/config";
import SearchBar from "material-ui-search-bar";
import moment from "moment";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectFarmList, selectLoading } from "../../adminSlice";
import LoadingComponent from "components/loading/Loading";

const useStyles = makeStyles({
  root: {
    paddingTop: 8,
    position: "relative",
  },
  paper: {
    width: "100%",
  },
  container: {
    // maxHeight: "1000px",
  },
  inputSearch: {
    borderRadius: 30,
    marginBottom: 20,
    marginTop: 10,
    padding: "5px 20px",
    "&:focus-within": {
      border: "1px solid #000",
    },
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#eaedf4",
    color: theme.palette.common.black,
    borderRight: "1px solid rgba(224, 224, 224, 1)",
  },
  body: {
    fontSize: 14,
    borderRight: "1px solid rgba(224, 224, 224, 1)",
  },
}))(TableCell);

const columns = [
  { id: "id", label: "ID", minWidth: 20, align: "center" },
  { id: "name", label: "Tên trại", minWidth: 120 },
  {
    id: "address",
    label: "Địa chỉ",
    minWidth: 170,
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "province",
    label: "Tỉnh",
    minWidth: 170,
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "staff",
    label: "Số nhân viên",
    minWidth: 50,
    format: (value) => value.toFixed(2),
  },

  {
    id: "createTime",
    label: "Ngày tạo trại",
    minWidth: 100,
    format: (value) => value.toFixed(2),
  },
  {
    id: "boss",
    label: "Nhân viên",
    minWidth: 170,
    format: (value) => value.toFixed(2),
  },
  {
    id: "company",
    label: "Công ty",
    minWidth: 170,
    format: (value) => value.toFixed(2),
  },
];
export default function ListFarm() {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const listFarm = useSelector(selectFarmList);
  const loading = useSelector(selectLoading);
  const [searched, setSearched] = useState("");

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const cancelSearch = () => {
    setSearched("");
  };

  const filteredRows = listFarm.filter((row) => {
    return removeAccents(row?.name).includes(searched.toLowerCase());
  });
  return (
    <Box className={classes.root}>
       <SearchBar
            value={searched}
            onChange={(searchVal) => setSearched(searchVal)}
            onCancelSearch={() => cancelSearch()}
            placeholder="Tìm kiếm theo tên trại"
            className={classes.inputSearch}
          />
      {loading ? (
        <LoadingComponent />
      ) : (
          <Paper className={classes.paper}>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <StyledTableCell
                        key={column.id}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredRows
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    ?.map((row) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                        >
                          <StyledTableCell align="center">
                            {row.id}
                          </StyledTableCell>
                          <StyledTableCell style={{ color: "#8f7bff" }}>
                            {row.name}
                          </StyledTableCell>
                          <StyledTableCell>{row.address}</StyledTableCell>
                          <StyledTableCell>{row.province}</StyledTableCell>
                          <StyledTableCell align="center">
                            {row.staffNo}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {/* {row.createTime} */}
                            {moment(row.createTime).format("DD/MM/YYYY")}
                          </StyledTableCell>
                          <StyledTableCell>{row.user.name}</StyledTableCell>
                          <StyledTableCell>{row.user.company}</StyledTableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              component="div"
              count={
                filteredRows?.length > 0
                  ? filteredRows?.length
                  : listFarm?.length
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
      )}
    </Box>
  );
}
